import React, { useEffect, useState } from "react";
import logoInitial from "../../assets/png/Netuno_Logo_dark.png";
import { textSignUp, textlogin } from "../../locales/es-es";
import { useForm } from "../../Hooks/UseForm";
import { validationSingUp } from "../../validations/formValidations";
import { Link, useNavigate } from "react-router-dom";
import { initialFormSignUp, optionLogin } from "../../propsType/SignUp";
import Spinner from "../../components/Loading/loadingSpinner/Spinner";
import InputGeneric from "../../components/Inputs/InputGeneric";
import ButtonGeneric from "../../components/Buttons/ButtonGeneric";
import SelectGeneric from "../../components/Inputs/SelectGeneric";
import AuthController from "../../controllers/AuthController";
import { extrac } from "../../helpers/selectForm";
import Modal from "../../components/Modals/Modal";
import { colors } from "../../propsType/Colors";
const SignUp = () => {

  const navigate = useNavigate();
  const [objetRegister, setObjetRegister] = useState("");
  const { registerDoc, register } = AuthController();
  const [stateValue, setStateValue] = useState(true);
  const [statebutton, setStatebutton] = useState(true);
  const [erros, setErros] = useState(false);
  const [imgModal, setImgModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [dataUser, setDataUser] = useState("");
  const [client, setClient] = useState("");
  const [correos, setCorreos] = useState(null)
  const [dataRegister, setDataRegister] = useState(false)
  const [message, setMessage] = useState('')
  const [checkButton, setCheckButton] = useState(true)
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const {
    form,
    errors,
    setForm,
    setErrors,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useForm(initialFormSignUp, validationSingUp, stateValue, setStatebutton);

  const funtionShowPassword = () => {setShowPassword(!showPassword);};
  const funtionConfirmShowPassword = () => {setShowConfirmPassword(!showConfirmPassword);};

  const sendLogin = async () => 
  {
    const result = handleSubmit();
    if (result === "ok") {
      setLoading(true);
      const { password, selectCorreo } = form;
      let resCorreo = JSON.parse(selectCorreo)

      let newObjet = {
        result: objetRegister.tipoDoc,
        password,
        typeDoc: objetRegister.id,
        idCorreo: resCorreo.id,
      };

         const res = await register(newObjet);

         if (res.respuesta === null) {
        setErros(true);
        setLoading(false);
        setMessage("El documento de identidad no se encuentra registrado en sistema. Por favor verifíquelo e intente nuevamente.")

      }

      else if (res.respuesta === "0") {
        setMessage(res.descripcion)
        setErros(true);
        setLoading(false);
        setImgModal(true);

      }
      else {
        setErros(true);
        setLoading(false);
        setMessage(res.descripcion);
      }
    }
  };
  const validarDatos = async () => {

    const result = handleSubmit();

    if (result === "ok") {
      const { typeDoc, selectDoc, password } = form;

      const result = extrac(selectDoc);
      let newObjet = {
        tipoDoc: result,
        password: password,
        id: typeDoc,
      };

      setDataRegister({ ...form })
      setLoadingButton(true);


      const res = await registerDoc(newObjet);

   

      if (res.correos === null)
      {
        setErros(true);
        setMessage('No tienes un correo electrónico asociado en tu cuenta. Comunícate a través de nuestros diferentes medios de contacto para actualizar tus datos.')
        setLoadingButton(false);

      }
     
      if (res.status === -1 && res.correos.length > 0)
       {
        setStatebutton(true)
        let newObjerCorreo = [
          {
            nombre: res?.correos[0]?.correo,
            codigo: res?.correos[0]?.id,
          },
          {
            nombre: res?.correos[1]?.correo,
            codigo: res?.correos[1]?.id,
          },
          {
            nombre: res?.correos[2]?.correo,
            codigo: res?.correos[2]?.id,
          }
        ]

        setCorreos(res.correos)
        if (res.status === 1) {

          setDataUser(null);
          setForm({
            ...form,
            selectDoc: "",
            typeDoc: "",
            password: "",
            email: "",
            name: "",
            date: "",
            phone: "",
            confirmPassword: "",
            social: "",
            selectCorreo: '',
            paso: false
          });
          setErros(true);
          setLoadingButton(false);
          setStateValue(true);
          setStatebutton(true);
        }
        else {

          setErrors('')
          setObjetRegister(newObjet);
          setDataUser(res);
          setForm({
            ...form,
            selectDoc: "",
            typeDoc: "",
            password: "",
            email: "",
            name: "",
            date: "",
            phone: "",
            confirmPassword: "",
            social: "",
            selectCorreo: '',
            paso: true
          });
          setTimeout(() => {
            setLoadingButton(false);
            setStateValue(false);
          }, 500);
        }
      }
      else if (res.status === -1 && res.correos.length === 0){
        setErros(true);
        setMessage('No tienes un correo electrónico asociado en tu cuenta. Comunícate a través de nuestros diferentes medios de contacto para actualizar tus datos.')
        setLoadingButton(false);
      }
      else {
        setErros(true);
        setMessage('El documento de identidad no se encuentra registrado en sistema. Por favor verifíquelo e intente nuevamente.')
        setLoadingButton(false);
      }
    } else {
      setForm({
        ...form,
        selectDoc: "",
        typeDoc: "",
        password: "",
        email: "",
        name: "",
        date: "",
        phone: "",
        confirmPassword: "",
        social: "",
        selectCorreo: '',
        paso: false
      });
      setCorreos(null)
      setStateValue(true);
      setErrors('')
      setStatebutton(true)

    }
  };
  const handle = (e) => {
    setErrors("");
    setForm({ ...form, selectDoc: "", typeDoc: "" });
    setClient(e);
  };

  const closetModal = () => {
    if (imgModal) {
     
      navigate('/cuenta')
    } else {
      setForm({
        ...form,
        selectDoc: "",
        typeDoc: "",
        password: "",
        email: "",
        name: "",
        date: "",
        phone: "",
        confirmPassword: "",
        social: "",
        selectCorreo: '',
        paso: false
      });
      setCorreos(null)
      setStateValue(true);
      setErrors(null)
      setErros(false)
      setStatebutton(true)
      setCheckButton(true)
    }
  }
  function filtro(e) {
    if (form.selectDoc !== "Pasaporte"){
    var tecla = e.key;
    if (['.', 'e','E' ].includes(tecla))
      e.preventDefault()}
  }

  useEffect(() => {

    if (form.password !== '' && form.confirmPassword !== '') {
      if (form.password === form.confirmPassword) {
        setCheckButton(false)
      } else {
        setCheckButton(true)
      }
    } else {
      setCheckButton(true)
    }

  }, [form.confirmPassword, form.password])

  return (
    <>
      <div className="h-screen  lg:flex">
        <div className="flex-1 h-screen flex flex-col w-auto xl:w-[44%]  py-4 xl:overflow-hidden justify-center   sm:px-6 md:flex-none lg:px-0 xl:px-0">
          {loading ? (
            <>
              {" "}
              <Spinner title={"Espere..."} />
            </>
          ) : (
            <>
              <div className="mx-auto w-full   overflow-y-auto lg:px-[100px] 2xl:px-[160px] md:px-[70px]  lg:mt-0 px-4 xl:max-[100%] xl:w-[100%]">
                <div className="relative">
                  <img
                    className="h-12 w-auto"
                    src={logoInitial}
                    alt="Workflow"
                  />
                  <h2 className="mt-6 mb-2 text-3xl font-extrabold text-gray-900">
                    {" "}
                    {textSignUp.ingresar}{" "}
                  </h2>
                  <p
                    className={`text-sm font-medium text-[${colors.darkBlue}]`}
                  >
                    {textSignUp.acceder}{" "}
                  </p>
                </div>
                <div className="mt-6 grid gap-4 ">
                  <div className="grid gap-6">
                    <div className="grid  gap-3">
                      <div className="text-sm !mb-[-0.50rem] font-medium text-gray-900">
                        {" "}
                        {textlogin.doc}
                      </div>
                      <div className="grid grid-cols-7">
                        <div className="col-span-2">
                          <SelectGeneric
                            onChange={handleChange}
                            value={form?.selectDoc}
                            name={"selectDoc"}
                            onBlur={handleBlur}
                            errors={errors?.selectDoc}
                            selectData={optionLogin}

                          />
                        </div>
                        <div className="col-span-5">
                          <InputGeneric
                            name={"typeDoc"}
                            type={form?.selectDoc === "Pasaporte" ? "text" : "number"}
                            onKeyDown={(e) => filtro(e)}
                            onBlur={handleBlur}
                            value={form?.typeDoc}
                            onChange={handleChange}
                            handleBlur={handleBlur}
                            errorText={errors?.typeDoc}
                            maxValue={13}
                          />
                        </div>
                      </div>
                      <ButtonGeneric
                        funtion={validarDatos}
                        text={"Validar Datos"}
                        loading={loadingButton}
                      />
                    </div>
                    <div className=" relative">
                      <div
                        className="absolute inset-0 flex items-center"
                        aria-hidden="true"
                      >
                        <div className="w-full border-t border-gray-300" />
                      </div>
                      <div className="relative flex justify-center text-sm">
                        <span className="px-2 bg-white text-gray-500">
                          Introducir datos
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="grid gap-[15px] ">
                    <InputGeneric
                      title={textSignUp.name}
                      llaveProps={!stateValue ? dataUser?.nombreApellido : ""}
                      disable={true}
                      defaultData={!stateValue ? dataUser?.nombreApellido : ""}
                      errorText={errors?.name}
                    />
                    <SelectGeneric
                      onChange={handleChange}
                      value={form?.selectCorreo || ''}
                      name={"selectCorreo"}
                      onBlur={handleBlur}
                      errors={errors?.selectCorreo}
                      selectData={correos || ['']}
                      disabled={correos ? false : true}
                    />
                    <InputGeneric
                      title={textSignUp.phone}
                      llaveProps={!stateValue ? dataUser?.maskTelefono : ""}
                      disable={true}
                      defaultData={!stateValue ? dataUser?.maskTelefono : ""}
                      errorText={errors?.phone}
                    />
                    <div className="grid grid-cols-2 gap-3">
                      <InputGeneric
                        title={textSignUp.password}
                        disable={stateValue}
                        name={"password"}
                        //type={"password"}
                        type={showPassword ? "text" : "password"}
                        show={showPassword}
                        funtionShow={funtionShowPassword}
                        value={form?.password}
                        onChange={handleChange}
                        handleBlur={handleBlur}
                        errorText={errors?.password}
                      />
                      <InputGeneric
                        title={textSignUp.confirmPassword}
                        disable={stateValue}
                        name={"confirmPassword"}
                        type={showConfirmPassword ? "text" : "password"}
                        show={showConfirmPassword}
                        funtionShow={funtionConfirmShowPassword}
                        value={form?.confirmPassword}
                        onChange={handleChange}
                        handleBlur={handleBlur}
                        errorText={errors?.confirmPassword}
                      />
                    </div>
                    <ButtonGeneric
                      text={"Registrar Cuenta"}
                      funtion={sendLogin}
                      disable={checkButton}
                    />
                    <div className="flex items-center justify-between">
                      <div className="flex items-center"></div>
                      <div className="text-sm">
                        <Link
                          to={"/cuenta"}
                          className={`font-medium text-[${colors.darkBlue}] hover:text-[${colors.darkBlue}]`}
                        >
                          {textSignUp.volver}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div
          className={`hidden bg-[url("../public/banner.jpg")] border-[${colors.darkBlue}] border-l-4 bg-cover bg-center bg-no-repeat lg:block relative w-0 flex-1`}
        ></div>
      </div>
      <Modal
        string={imgModal ? 'check' : "error"}
        active={erros}
        message={message}
        setActive={setErros}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <button

            type="button"
            onClick={closetModal}
            className={` ${imgModal ? 'bg-green-500' : 'bg-red-500'}  inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto`}
          >
            Cerrar
          </button>
        </div>
      </Modal>
    </>
  );
};

export default SignUp;
